import { Types } from '../actions/taskActions';
import moment from 'moment';

const initialState = {
    filterModel: {
        serviceShopId: [],
        statusId: [],
        startDate: moment()
            .startOf('day')
            .add(-7, 'days')
            .add(12, 'hours')
            .format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        openCase: false,
        openDay: null
    },
    response: {
        tasksScreenResult: [],
        excelDetailedDatas: []
    },
    isRequestSending: false,
    requestFailed: false
};

export const tasksNewReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_TASKS_FILTER: {
            const { name, value } = action.payload;
            return {
                ...state,
                filterModel: {
                    ...state.filterModel,
                    [name]: value
                }
            }
        }

        case Types.SET_FILTERED_TASKS: {
            return {
                ...state,
                response: action.payload
            }
        }


        case Types.SET_REQUEST_STATUS: {
            return {
                ...state,
                isRequestSending: action.payload
            }
        }

        case Types.SET_FILTERED_TASKS_ERROR: {
            return {
                ...state,
                requestFailed: action.payload
            }
        }

        default:
            return state;
    }

}